import { useEffect } from "react";
import { useHasBackgroundImage } from "./Layout/useHasBackgroundImage";
import { Colors } from "Components/Layout/Themes/Colors";

export const useSetStatusBarColor = () => {
  const { hasBackgroundImage } = useHasBackgroundImage();

  useEffect(() => {
    const metaThemeColorElement = document.querySelector(
      'meta[name="theme-color"]',
    );

    if (metaThemeColorElement) {
      const color = hasBackgroundImage ? Colors.SpaceBlack : Colors.Gray;
      metaThemeColorElement.setAttribute("content", color);
    }
  }, [hasBackgroundImage]);
};
